var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-popover",
    {
      attrs: {
        placement: "bottomRight",
        overlayClassName: "avatar-popover-overlay",
        trigger: ["hover"],
      },
      on: { visibleChange: _vm.visibleChange },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "200px",
                padding: "15px 12px",
                display: "flex",
                "align-items": "center",
              },
              style: _vm.note,
            },
            [
              _vm.userInfo
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-right": "10px",
                        "border-radius": "50%",
                        width: "32px",
                        height: "32px",
                        "font-size": "20px",
                        "text-align": "center",
                        overflow: "hidden",
                      },
                      style: {
                        background: !_vm.userInfo.headImgUrl
                          ? "#d1d1d1"
                          : "#fff",
                      },
                    },
                    [
                      !_vm.userInfo.headImgUrl
                        ? _c("icon-font", {
                            staticClass: "gb-icon-user",
                            staticStyle: { color: "#fff" },
                            attrs: { type: "gb-icon-user" },
                          })
                        : _c("img", {
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              display: "block",
                            },
                            attrs: { src: _vm.userInfo.headImgUrl },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticStyle: { flex: "1", "min-width": "0" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#1E1E28",
                      "font-size": "14px",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("userName")(_vm.userInfo)))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#484848",
                      "font-size": "12px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [_vm._v(_vm._s(_vm.packageName))]
                    ),
                    _c("div", { staticClass: "btn_login" }, [
                      _c(
                        "a",
                        {
                          staticStyle: { color: "#fff" },
                          on: {
                            click: function ($event) {
                              return _vm.handleMenuClick({ key: "user" })
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.i18nRender("layouts.upgrade")) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "a-menu",
            {
              attrs: {
                mode: "vertical",
                selectable: false,
                openKeys: _vm.openKeys,
              },
              on: {
                "update:openKeys": function ($event) {
                  _vm.openKeys = $event
                },
                "update:open-keys": function ($event) {
                  _vm.openKeys = $event
                },
                click: _vm.handleMenuClick,
                openChange: _vm.handleSubMenuOpenChange,
                mousemove: _vm.handleSubMenuMove,
              },
            },
            [
              _c(
                "a-menu-item",
                { key: "home" },
                [
                  _c("icon-font", {
                    staticClass: "iconFont",
                    attrs: { type: "gb-icon-a-01" },
                  }),
                  _c("div", [
                    _vm._v(_vm._s(_vm.i18nRender("layouts.usercenter"))),
                  ]),
                ],
                1
              ),
              _c(
                "a-menu-item",
                { key: "productPackage" },
                [
                  _c("icon-font", {
                    staticClass: "iconFont",
                    attrs: { type: "gb-icon-zijinzhushou" },
                  }),
                  _c("div", [
                    _vm._v(_vm._s(_vm.i18nRender("layouts.productPackage"))),
                  ]),
                ],
                1
              ),
              _c(
                "a-menu-item",
                { key: "accountSettings" },
                [
                  _c("icon-font", {
                    staticClass: "iconFont",
                    attrs: { type: "gb-icon-a-02" },
                  }),
                  _c("div", [
                    _vm._v(_vm._s(_vm.i18nRender("layouts.accountSettings"))),
                  ]),
                ],
                1
              ),
              _vm.menus.length
                ? _c(
                    "a-menu-item",
                    { key: "authority" },
                    [
                      _c("icon-font", {
                        staticClass: "iconFont",
                        attrs: { type: "gb-icon-a-03" },
                      }),
                      _c("div", [
                        _vm._v(_vm._s(_vm.i18nRender("layouts.authority"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.menus.length
                ? _c(
                    "a-menu-item",
                    { key: "store" },
                    [
                      _c("icon-font", {
                        staticClass: "iconFont",
                        attrs: { type: "gb-icon-dianpu2" },
                      }),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.i18nRender("layouts.store.authorization"))
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isDemo && _vm.isAppear
                ? _c(
                    "a-menu-item",
                    { key: "money" },
                    [
                      _c("icon-font", {
                        attrs: { type: "gb-icon-zijinzhushou" },
                      }),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.i18nRender("layouts.MoneyAssistant"))
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isDemo && _vm.systemCode === "ERP" && !_vm.isSellerwell()
                ? _c(
                    "a-menu-item",
                    { key: "app" },
                    [
                      _c("icon-font", {
                        staticStyle: { "margin-right": "13px" },
                        attrs: { type: "gb-icon-app-marketplace" },
                      }),
                      _c("span", { staticStyle: { "padding-right": "0" } }, [
                        _vm._v(_vm._s(_vm.$t("layouts.应用市场"))),
                      ]),
                      _vm.localDefaultConfig.appNew
                        ? _c("span", { staticClass: "safe-new" })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isSellerwell()
                ? _c(
                    "a-menu-item",
                    { key: "live" },
                    [
                      _c("icon-font", {
                        staticStyle: { "margin-right": "13px" },
                        attrs: { type: "gb-icon-shiliangzhinengduixiang-07" },
                      }),
                      _c("span", { staticStyle: { "padding-right": "0" } }, [
                        _vm._v(_vm._s(_vm.$t("layouts.易学堂（直播/回放）"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-sub-menu",
                {
                  key: "syl",
                  attrs: { popupClassName: "avatar-menu-sub-popup" },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("icon-font", {
                        staticClass: "iconFont",
                        attrs: { type: "gb-icon-a-04" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.i18nRender("layouts.menusyl")) + " "
                      ),
                      _c("icon-font", {
                        staticClass: "rotate anticon-right",
                        attrs: { type: "gb-icon-Down" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-menu-item",
                    [
                      _c(
                        "a-tooltip",
                        { attrs: { placement: "left" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.i18nRender("layouts.menusyl.top"))
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "layout-syl-ob-item",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.saveUseNewMenu(2)
                                },
                              },
                            },
                            [
                              _vm.userConfig.packageStyle === "2"
                                ? _c("a-icon", { attrs: { type: "check" } })
                                : _vm._e(),
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/layout1.png"),
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-menu-item",
                    [
                      _c(
                        "a-tooltip",
                        { attrs: { placement: "left" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.i18nRender("layouts.menusyl.left"))
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "layout-syl-ob-item",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.saveUseNewMenu(1)
                                },
                              },
                            },
                            [
                              _vm.userConfig.packageStyle === "1"
                                ? _c("a-icon", { attrs: { type: "check" } })
                                : _vm._e(),
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/layout2.png"),
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "a-sub-menu",
                {
                  key: "lang",
                  attrs: {
                    popupClassName: "avatar-menu-sub-popup national-popup",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("icon-font", {
                        staticClass: "iconFont",
                        attrs: {
                          type: _vm.languageCodes[_vm.currentLang].icon,
                        },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.i18nRender("layouts.langset")) + " "
                      ),
                      _c("icon-font", {
                        staticClass: "rotate anticon-right",
                        attrs: { type: "gb-icon-Down" },
                      }),
                    ],
                    1
                  ),
                  _vm._l(Object.keys(_vm.languageCodes), function (code) {
                    return _c(
                      "a-menu-item",
                      {
                        key: code,
                        staticClass: "layout-syl-ob-item-national",
                        class: {
                          "home-ant-menu-item-active": code === _vm.currentLang,
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            staticStyle: { width: "16px", height: "11px" },
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                "xlink:href": `#icon-${_vm.languageCodes[code].flag}`,
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          " " + _vm._s(_vm.languageCodes[code].label) + " "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "a-menu-item",
                { key: "logout" },
                [
                  _c("icon-font", {
                    staticClass: "iconFont",
                    attrs: { type: "gb-icon-a-05" },
                  }),
                  _c("div", [_vm._v(_vm._s(_vm.i18nRender("layouts.logout")))]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-content__action" },
        [
          !_vm.userInfo.headImgUrl
            ? _c("icon-font", {
                staticClass: "gb-icon-user",
                attrs: { type: "gb-icon-user" },
              })
            : _c("img", {
                staticStyle: {
                  width: "22px",
                  height: "22px",
                  "border-radius": "50%",
                  background: "#fff",
                },
                attrs: { src: _vm.userInfo.headImgUrl },
              }),
          _c("span", { staticStyle: { "margin-left": "8px" } }, [
            _vm._v(_vm._s(_vm._f("userName")(_vm.userInfo))),
          ]),
          _c("icon-font", {
            staticStyle: { "margin-left": "10px" },
            attrs: { type: "gb-icon-Down" },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }